export default __webpack_public_path__ + "static/media/upload-exam-icon.7dba6574.svg";